import React from 'react';

export const AiIcon: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M6.6867 2.83747C6.60714 2.35443 6.18956 2 5.7 2C5.21044 2 4.79286 2.35443 4.7133 2.83748C4.6133 3.44455 4.39371 3.8516 4.1155 4.1271C3.83631 4.40358 3.42903 4.61586 2.83748 4.7133C2.35443 4.79286 2 5.21044 2 5.7C2 6.18956 2.35443 6.60714 2.83747 6.6867C3.44455 6.7867 3.8516 7.00629 4.1271 7.2845C4.40358 7.56369 4.61586 7.97097 4.7133 8.56252C4.79286 9.04557 5.21044 9.4 5.7 9.4C6.18956 9.4 6.60714 9.04557 6.6867 8.56253C6.78414 7.97097 6.99642 7.56369 7.2729 7.2845C7.5484 7.00629 7.95545 6.7867 8.56253 6.6867C9.04557 6.60714 9.4 6.18956 9.4 5.7C9.4 5.21044 9.04557 4.79286 8.56252 4.7133C7.95545 4.6133 7.5484 4.39371 7.2729 4.1155C6.99642 3.83631 6.78414 3.42902 6.6867 2.83747Z"
        fill="url(#paint0_linear_4679_623)"
      />
      <path
        d="M13.892 2.87392C13.8285 2.3744 13.4035 2 12.9 2C12.3965 2 11.9715 2.3744 11.908 2.87392C11.5859 5.40808 10.9021 7.2346 9.78969 8.51626C8.69227 9.78066 7.07621 10.6306 4.64499 11.0121C4.1585 11.0884 3.8 11.5076 3.8 12C3.8 12.4924 4.1585 12.9116 4.64499 12.9879C7.07621 13.3694 8.69227 14.2193 9.78969 15.4837C10.9021 16.7654 11.5859 18.5919 11.908 21.1261C11.9715 21.6256 12.3965 22 12.9 22C13.4035 22 13.8285 21.6256 13.892 21.1261C14.2141 18.5919 14.8979 16.7654 16.0103 15.4837C17.1077 14.2193 18.7238 13.3694 21.155 12.9879C21.6415 12.9116 22 12.4924 22 12C22 11.5076 21.6415 11.0884 21.155 11.0121C18.5917 10.6099 16.9738 9.7062 15.9071 8.42658C14.8209 7.12345 14.2012 5.30628 13.892 2.87392Z"
        fill="url(#paint1_linear_4679_623)"
      />
      <path
        d="M6 17.65C6 17.0977 5.55228 16.65 5 16.65C4.44772 16.65 4 17.0977 4 17.65V18H3.65C3.09772 18 2.65 18.4477 2.65 19C2.65 19.5523 3.09772 20 3.65 20H4V20.35C4 20.9023 4.44772 21.35 5 21.35C5.55228 21.35 6 20.9023 6 20.35V20H6.35C6.90228 20 7.35 19.5523 7.35 19C7.35 18.4477 6.90228 18 6.35 18H6V17.65Z"
        fill="url(#paint2_linear_4679_623)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4679_623"
          x1="13.5"
          y1="5.5"
          x2="5.5"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#DF99FF" />
          <stop offset="0.195" stop-color="#CD66FC" />
          <stop offset="0.62664" stop-color="#9700DC" />
          <stop offset="1" stop-color="#510076" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4679_623"
          x1="13.5"
          y1="5.5"
          x2="5.5"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#DF99FF" />
          <stop offset="0.195" stop-color="#CD66FC" />
          <stop offset="0.62664" stop-color="#9700DC" />
          <stop offset="1" stop-color="#510076" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4679_623"
          x1="13.5"
          y1="5.5"
          x2="5.5"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#DF99FF" />
          <stop offset="0.195" stop-color="#CD66FC" />
          <stop offset="0.62664" stop-color="#9700DC" />
          <stop offset="1" stop-color="#510076" />
        </linearGradient>
      </defs>
    </svg>
  );
};
